import { render, staticRenderFns } from "./shuzinongyeDetails.vue?vue&type=template&id=f334875e"
import script from "./shuzinongyeDetails.vue?vue&type=script&lang=js"
export * from "./shuzinongyeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports